'use strict';

import app from './ngmodule';
import './other';

export default app;